import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
interface WaitlistIsotypeProps {
  className?: string;
}
function WaitlistIsotype(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("size-[22px] shrink-0 sm:size-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g><path d="M 11.859 14.966 C 15.186 14.956 18.378 16.268 20.719 18.607 C 21.283 19.168 21.792 19.781 22.239 20.438 C 22.462 20.765 22.315 21.206 21.947 21.359 L 18.139 22.949 C 17.858 23.066 17.534 22.975 17.337 22.745 C 16.742 22.054 16.019 21.482 15.207 21.06 C 14.174 20.524 13.025 20.247 11.859 20.252 C 9.75 20.243 7.745 21.155 6.381 22.745 C 6.183 22.975 5.86 23.066 5.579 22.949 L 1.771 21.359 C 1.403 21.205 1.255 20.766 1.478 20.438 C 1.925 19.781 2.435 19.168 2.999 18.607 C 5.34 16.268 8.532 14.956 11.859 14.966 Z" fill="rgb(122, 59, 255)" /><path d="M 5.339 2.316 C 5.301 2.005 5.464 1.698 5.757 1.579 L 9.542 0.049 C 9.906 -0.099 10.32 0.1 10.405 0.48 C 10.602 1.356 10.706 2.267 10.706 3.202 C 10.706 9.203 6.431 14.211 0.747 15.375 C 0.335 15.46 -0.03 15.12 0.002 14.704 L 0.335 10.457 C 0.36 10.192 0.537 9.964 0.79 9.872 C 3.57 8.802 5.399 6.152 5.394 3.202 C 5.394 2.902 5.376 2.606 5.339 2.316 Z" fill="rgb(122, 59, 255)" /><path d="M 18.606 3.202 C 18.601 6.152 20.431 8.802 23.211 9.872 C 23.462 9.968 23.645 10.192 23.665 10.457 L 23.998 14.704 C 24.03 15.12 23.666 15.46 23.254 15.375 C 17.569 14.211 13.294 9.203 13.294 3.202 C 13.294 2.267 13.398 1.356 13.595 0.48 C 13.68 0.1 14.094 -0.099 14.458 0.049 L 18.243 1.579 C 18.536 1.698 18.7 2.005 18.661 2.316 C 18.625 2.61 18.606 2.906 18.606 3.202 Z" fill="rgb(122, 59, 255)" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <svg className={t1} viewBox="0 0 24 23" overflow="visible" aria-hidden={true}>{t2}</svg>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export { WaitlistIsotype };